<app-dialog
        [dialogWithInput]="dialog">
    <app-create-update-default #createUpdateDefaultComponent
                               [formGroup]="formGroup"
                               [id]="id"
                               (entitySaved)="entitySaved($event)"
                               (entityLoaded)="entityLoaded($event)"
                               [dontGoBakOnSaveSuccess]="true"
                               [service]="service"
                               [findOneService]="findOneService"
                               [hideSaveButton]="true">
        <ng-template template-content>
            <app-card-v2 [hideHeader]="true">
                <div class="row">
                    <app-form-field label="Date" required="true" sizeLg="4" sizeXl="2" *ngIf="formGroup.get('date')">
                        <app-date-picker [parentFormGroup]="formGroup" parentFormControlName="date"
                                         style="width: 100%;"></app-date-picker>
                    </app-form-field>
                </div>
                <div class="row">
                    <app-form-field label="Mot(s) clé(s)" size="12">
                        <app-medical-record-visit-reason-labels-select-filter [parentFormGroup]="formGroup"
                                                                              parentFormControlName="labelNames">
                        </app-medical-record-visit-reason-labels-select-filter>
                    </app-form-field>
                    <app-form-field label="Problème(s)" size="12">
                        <app-medical-record-problem-multiple-select-filter
                                [parentFormGroup]="formGroup"
                                [partnerId]="partnerId"
                                [consultationSummary]="dialog.input.consultationSummary"
                                parentFormControlName="problemIds">
                        </app-medical-record-problem-multiple-select-filter>
                    </app-form-field>
                    <app-form-field label="Douleur(s)" size="12">
                        <app-medical-record-pain-multiple-select-filter
                                [parentFormGroup]="formGroup"
                                [partnerId]="partnerId"
                                [consultationSummary]="dialog.input.consultationSummary"
                                parentFormControlName="painIds">
                        </app-medical-record-pain-multiple-select-filter>
                    </app-form-field>
                </div>
                <div class="row">
                    <app-form-field label="Commentaire2" size="12">
                        <app-rich-text-editor [parentFormGroup]="formGroup"
                                              parentFormControlName="comment"
                                              [audioTranscriptionConfig]="audioTranscriptionConfig"></app-rich-text-editor>
                    </app-form-field>
                </div>
            </app-card-v2>
        </ng-template>
    </app-create-update-default>
    <ng-container dialog-actions>
        <app-loading [loading]="createUpdateDefaultComponent.saveLoading" [showText]="false"></app-loading>
        <app-button (click)="executeSave()" [disabled]="!formGroup.valid" fill="solid" size="small"
                    color="primary" iconName="check" label="Enregistrer" *ngIf="!createUpdateDefaultComponent.saveLoading &&
                !createUpdateDefaultComponent.loading && !createUpdateDefaultComponent.findOneError"></app-button>
    </ng-container>
</app-dialog>

